/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { mailFormList } from '../../apis/admin/newsletter';
import { getParams } from '../../utils/params';
import Filters from '../Filters';
import { ControlTable } from '../Table';
import MailForm from '../newsletter/MailForm';
import { isEmpty } from '../../utils/lodashExtend';
import { isEqual } from 'lodash';
import MailSendModal from '../newsletter/MailSendModal';
import TestMailSendModal from '../newsletter/TestMailSendModal';
import { useSelector } from 'react-redux';
import { getPartner } from '../../apis/partner/partner';

const MailForms = () => {
  const { company } = useSelector((store) => store.Profile);
  const [filters] = useState([
    {
      title: "제목",
      key: "search.name",
      options: {
        placeholder: "제목 입력",
      },
    },
  ]);
  const [fields] = useState([
    { title: "제목", key: "title" },
    { title: "등록일", key: "createdTime", type: "datetime" },
    {
      type: "button",
      size: "x-sm",
      color: "gray-line",
      label: "상세보기",
      onClick: ({ data }) => {
        setDetailOpen(true);
        setSelectedItem(data);
      },
    },
  ]);


  const [tableButtons, setTableButtons] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [mailOpen, setMailOpen] = useState(false);
  const [testMailOpen, setTestMailOpen] = useState(false);
  const [convertData, setConvertData] = useState({});


  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    selectedList, setSelectedList
  } = useForm({
    order: [
      {
        idx: "desc"
      },
    ],
    search: {
      type: "PARTNER",
      isHide: 0
    },
    page: 0,
    limit: 10,
  },);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  useEffect(() => {
    if (!isEmpty(company)) {
      const _company = company.type !== company.companyType ? company.taxCompany : company;
      const convert = {
        companyLogo: "",
        homePage: "",
        instagram: "",
        blog: "",
        youtube: "",
        ceoName: "",
        tel: "",
        fax: !isEmpty(_company?.fax) ? `fax: ${_company.fax}` : "",
        address: "",
        companyName: "",
      };

      getPartner(_company?.idx).then(partner => {
        convert.companyName = partner.name;
        convert.companyLogo = !isEmpty(partner.logoFile?.fileUrl)
          ? !isEmpty(partner.homepage)
            ? `<a href="${partner.homepage}" target="_blank"><img style="max-width: 200px; padding-left: 20px" src="${partner.logoFile?.fileUrl}" style="max-width: 200px" /></a>`
            : `<img src="${partner.logoFile?.fileUrl}" />`
          : `<span style="font-size: 28px;font-weight: bold;">${partner.name}</span>`;
        convert.homePage = !isEmpty(partner.homepage)
          ? `<a style="float: left; padding-right: 1em;" target="_blank" href="${partner.homepage}" alt="홈페이지" ><img src="https://smileceo-files.s3.ap-northeast-2.amazonaws.com/025020a0-efb8-11ed-8350-7f20f5b35c5a549f7b15-beab-4078-9f19-e4b2db061fb5.png" /></a>`
          : "";

        convert.blog = !isEmpty(partner.blog)
          ? `<a style="float: left; padding-right: 1em;" target="_blank" href="${partner.blog}" alt="블로그"><img src="https://smileceo-files.s3.ap-northeast-2.amazonaws.com/9b044550-efb9-11ed-8350-7f20f5b35c5a2d0f35b7-e0bd-4480-a9c3-5c86260bad08.png"/></a>`
          : "";
        convert.instagram = !isEmpty(partner.instar)
          ? `<a style="float: left; padding-right: 1em;" target="_blank" href="${partner.instar}" alt="인스타그램" ><img src="https://smileceo-files.s3.ap-northeast-2.amazonaws.com/b9cc0fe0-efb9-11ed-8350-7f20f5b35c5afb7e7613-b113-4298-85f1-dbd580bfea59.png"/></a>`
          : "";

        convert.youtube = !isEmpty(partner.youtube)
          ? `<a style="float: left; padding-right: 1em;" target="_blank" href="${partner.youtube}" alt="유튜브"><img src="https://smileceo-files.s3.ap-northeast-2.amazonaws.com/b09c60a0-efb9-11ed-8350-7f20f5b35c5a2f9a48d4-6c4a-4597-9227-e27660ca28ba.png" /></a>`
          : "";

        convert.homePageUrl = partner.homepage;
        convert.blogUrl = partner.blog;
        convert.instagramUrl = partner.instar;
        convert.youtubeUrl = partner.youtube;

        convert.ceoName = partner.ceoName ? `세무사 ${_company.ceoName}` : "";
        convert.address = !isEmpty(partner.address) ? `사업장 주소: ${partner.address} ${partner.addressDetail}` : "";
        convert.tel = `${!isEmpty(partner.tel) ? `${partner.tel}` : ""}${!isEmpty(partner.tel) && !isEmpty(partner.email) ? ` / ` : ""}${!isEmpty(partner.email) ? `${partner.email}` : ""}`;
        setConvertData(convert);
      });
    }
  }, [company]);


  const submit = (param) => {
    mailFormList(getParams(param))
      .then((res) => {
        setList(res.rows);
        setTotal(res.count);
      }).catch((err) => {
        console.error(err.response);
      }).finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    setTableButtons([
      {
        label: "테스트메일 발송하기",
        disabled: isEmpty(selectedList) || selectedList.length > 1,
        action: () => {
          setTestMailOpen(true);
          setSelectedItem(selectedList[0]);
        }
      },
      {
        label: "메일 발송하기",
        disabled: isEmpty(selectedList) || selectedList.length > 1,
        action: () => {
          setMailOpen(true);
          setSelectedItem(selectedList[0]);
        }
      },
    ]);
  }, [selectedList]);

  const getCheckboxDisabled = (data) => {
    return !isEmpty(selectedList) && !isEqual(selectedList[0], data);
  };

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        isControl={true}
        isHideAllCheck
        checkboxDisabled={getCheckboxDisabled}
      />

      <MailForm
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={filterSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        type="PARTNER"
        convertData={convertData}
      />
      <TestMailSendModal
        open={testMailOpen}
        setOpen={setTestMailOpen}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        type={"PARTNER"}
      />

      <MailSendModal
        open={mailOpen}
        setOpen={setMailOpen}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        type={"PARTNER"}
      />
    </>
  );
};

export default MailForms;